module.exports = window.jimdoData || window.parent.jimdoData;


//////////////////
// WEBPACK FOOTER
// external "window.jimdoData || window.parent.jimdoData"
// module id = 2
// module chunks = 174 178 179 182 184 185 186 189 190 193 194 196 197 198